import { EventListjson } from "./EventList";
import {
  executeDBLinking,
  executeCustomService,
  exportToPDF,
} from "../../components/IFormDesignerLayout/RequestLogic";
import {
  renderExecuteServerEventAPIData,
  functions,
  recursiveJsonReader1,
  generalError_fn,
} from "../../components/IFormDesignerLayout/ApplicationAPI/applicationApi";
import { getHooksId } from "../../Resources/globalFunctions";
import axios from "../../axios";
import { formStateStore } from "../../Redux/Store/store";
import { updateStore } from "../../Redux";
import {
  getFormJsonFromStore,
  getSelectedTableRow,
  getFormId,
  encrypt
} from "../../components/IFormDesignerLayout/IFormDesignerLogic";
import secureLocalStorage from "react-secure-storage";
import { updateRouteJourneySelectionPage,updateFormState,setFormState1,setGeneralData, updateFormStateContext, updateStateInRedux, updateFormStateWithoutRender} from "../../Redux/Actions/FormStateActions";
import { ReactReduxContext , batch} from 'react-redux';
import { handleWinObjects } from "../../components/IFormDesignerLayout/ReUsableLogics";

function executeWebService(id, eventtype, gdtoken, witoken) {
  let jsonToSend = {
    controlId: id,
    eventType: eventtype,
    gdtoken: gdtoken,
    witoken: witoken,
  };
  return axios.post("/viewform/executeWebService", jsonToSend, {
    withCredentials: true,
  });
}

const executeRestApi = (Endpointname, id, eventtype, gdtoken, witoken) => {
  let jsonToSend = {
    restEndPoint: Endpointname,
    controlId: id,
    eventType: eventtype,
    gdtoken: gdtoken,
    witoken: witoken,
  };

  return axios.post("viewform/executeRestApi", jsonToSend, {
    withCredentials: true,
  });
};

export async function triggerEventCalls(
  event,
  ref,
  eventJson,
  elementType,
  showAlertConfirmNotifications,
  reduxContexts,
  containerId,
  controlData,
  eventName,
  selectedTileIndex,
  updatedComponentInFormState,
  builderMode
) {
  if (reduxContexts.gdtoken && reduxContexts.witoken) {
    const setLoginErrorPage = reduxContexts?.contexts?.setLoginErrorPage;
    const setFormState2 = reduxContexts?.contexts?.setFormState2;
    const formState2 = reduxContexts?.contexts?.formState2;
    const setActivePage = reduxContexts?.contexts?.setActivePage;
    const isLoginTypeVar = reduxContexts?.contexts?.isLoginTypeVar;
    const setSelectionPage = reduxContexts?.contexts?.setSelectionPage;

    const gdtoken = reduxContexts?.gdtoken;
    const witoken = reduxContexts?.witoken;
    const openingAsApplication= reduxContexts?.contexts?.openingAsApplication;
    const formId= reduxContexts?.contexts?.formState2?.formId || getFormId();

    const eventList = EventListjson;
    const elementEventArrayJson = eventList[elementType]["controls"];
    var eventsArray = null;

    function saveApplicationData(){
      
      const applicationDataJson={
          "gdtoken":gdtoken,
          "witoken":witoken,
          "applicationId":openingAsApplication.applicationId,
          "applicationName": openingAsApplication.applicationName,
          "submitApplication": "Y",
          "stepIndex": "0",
          "stepSubIndex": "0",
          "isBackClicked": false,
          "formName": formId,
          "eventSource": controlData?.eventSource
      }

      axios.post("/viewform/saveApplicationData",applicationDataJson,{withCredentials:true})
      .then((response)=>{
        console.log("Full Response eventexec", response);
          if(response?.data?.APIData) {
              renderExecuteServerEventAPIData({outputArray: response?.data?.APIData, renderFlag: true, sync: true});
          }
          if (response?.headers?.error === "1"){
            // functions.showMess(["Workitem not Created."], "error")
            if(response?.headers?.errormessage){
                showAlertConfirmNotifications({
                    'open':true,
                    'showConfirm':'showNotification',
                    'alertType':'error',
                    "vertical": 'bottom', 
                    "horizontal": 'left',
                    'alertContentKey': `${response?.headers?.errormessage}`,
                    'autoHideDuration': 3000
                });
            } else {
              showAlertConfirmNotifications({
                'open':true,
                'showConfirm':'showNotification',
                'alertType':'error',
                "vertical": 'bottom', 
                "horizontal": 'left',
                'alertContentKey': `We encountered an issue while submitting your application. Please try again after some time.`,
                'autoHideDuration': 3000
              });
            }
          }
          else if (response?.headers?.error === "2"){
            // functions.showMess(["Workitem not Created."], "error")
            showAlertConfirmNotifications({
                'open':true,
                'showConfirm':'showNotification',
                'alertType':'error',
                "vertical": 'bottom', 
                "horizontal": 'left',
                'alertContentKey': `We encountered an issue while submitting your application. Please try again after some time.`,
                'autoHideDuration': 3000
            });
          }
          else if (response?.headers?.error === "3"){
            // functions.showMess(["Workitem not Created."], "error")
            showAlertConfirmNotifications({
                'open':true,
                'showConfirm':'showNotification',
                'alertType':'error',
                "vertical": 'bottom', 
                "horizontal": 'left',
                'alertContentKey': `We encountered an issue while submitting your application. Please try again after some time.`,
                'autoHideDuration': 3000
            });
          }
          else if(response?.headers?.workitemlist !== undefined && response?.headers?.workitemlist !== ""){

            // shivam_review correction needed @avinash (workitemlist message stopped coming )
            if(window.showSuccessMessageInApplication){
              window.showSuccessMessageInApplication(response.headers.workitemlist);
            }
            showAlertConfirmNotifications({
                'open':true,
                'showConfirm':'showNotification',
                'alertType':'success',
                "vertical": 'bottom', 
                "horizontal": 'left', 
                'alertContentKey':`${response.headers.workitemlist} created successfully`,
                'autoHideDuration': 3000
            });
          }
          try {
            if(window?.postSaveApplication) {
                window.postSaveApplication();
                functions.updateJSON()
            }
          } catch(err){
              console.log("postSaveApplication error", err);
          }     
      })
      .catch(err =>{
      })        
  }

    const webServiceFunction = async(response) => {
      var jsonObj, tableObj;
      var type, tableId;
      let response1 = response.data ? response : {};
      let responseData = response1.data ? response1?.data : {};
      if (responseData?.ResponseCode === "0" && responseData?.message === "") {
        jsonObj = {};
        if (Array.isArray(responseData?.WSDATA[0])) {
          if (responseData?.WSDATA[0]?.length > 0) {
            for (let i of responseData?.WSDATA[0]) {
              jsonObj[i.id] = i?.value?.value;
              type = i.type;
            }
          }
        }
        let primitiveFieldJSON = {};
        if (Array.isArray(responseData?.WSDATA[0])) {
          for (let item of responseData.WSDATA[0]) {
            if (item.type !== "table" && item.type !== "listview") {
              primitiveFieldJSON[item.id] = item.value.value;
            }
          }
        }
        if(responseData?.APIData?.length > 0){
          var apiArray = responseData.APIData;
          if (apiArray != null)
            renderExecuteServerEventAPIData({
              outputArray: apiArray,
              isCalledFromDBLinking: false,
              event: eventType,
              renderFlag: true,
              // index: j,
              sync: true,
            });
        }
        await functions.setValues(primitiveFieldJSON, true);
        formState2.isExecuteWebService = true;
        if (type === "listview" || type === "table") {
          if (Array.isArray(responseData?.WSDATA[0])) {
            for (let item of response.data.WSDATA[0]) {
              if (item.type === "table" || item.type === "listview") {
                let id = item.id;
                let tableJson = item.value.value;
                let json = functions.readJson(formState2, id);
                json.style.updateFormState = new Date();
                functions.setListViewTableData(tableJson, id, true);
              }
            }
          }
        }
        functions.updateJSON();
      } else {
      }
    };
    for (var i = 0; i < elementEventArrayJson.length; i++) {
      var control = elementEventArrayJson[i];
      var eventType = event.type;
      if (event.type == "input") eventType = "change";
      if (
        control.value.toLowerCase() === "gotfocus" &&
        eventType.toLowerCase() === "focus"
      ) {
        eventType = "gotfocus";
      }
      if (
        control.value.toLowerCase() === "lostfocus" &&
        eventType.toLowerCase() === "blur"
      ) {
        eventType = "lostfocus";
      }
      if (control.value.toLowerCase() === eventType.toLowerCase()) {
        eventsArray = control.events;
        break;
      }
    }
    let elementEventJson = [];
    if (event.type == "click") {
      if (eventJson && eventJson.Events && eventJson.Events["Click"]) {
        elementEventJson = eventJson.Events["Click"];        
        if (eventJson.Events["Click"]?.ReusableCustomCode) {
          if (window.webServicePreHook) {
            if (!window.webServicePreHook(getHooksId(controlData))) {
              return;
            }
            functions.updateJSON()
          }

          executeRestApi(
            eventJson.Events["Click"]?.ReusableCustomCode[0]?.name,
            controlData.id,
            eventName,
            reduxContexts.gdtoken,
            reduxContexts.witoken
          )
            .then((response) => {
              if (response && response.data && response.data.status === "0") {
                var apiArray = response.data.APIData;
                if (apiArray != null)
                  renderExecuteServerEventAPIData({
                    outputArray: apiArray,
                    isCalledFromDBLinking: false,
                    event: eventType,
                    renderFlag: true,
                    // index: j,
                    sync: true,
                  });
              }
              if (window.webServicePostHook) {
              if (!window.webServicePostHook(controlData.id)) {
                return;
              }
              functions.updateJSON()
            }
            })
            .catch((err) => {
              console.log("ExecuteAPI Failed");
            });
        }
        else if(eventJson.Events["Click"]?.Command){
          if(eventJson.Events["Click"]?.Command.Name==="CreateWorkitem" && window.isComponentValidated()===true ){

            if(controlData?.routeto && controlData?.routeto!=="Select" && controlData?.routeto.toLowerCase()!=="select"){

              const formName= controlData?.routeto;
              const DecisionField = null;
              const controlId= controlData.id;

              executeRouteJourney1(formName ,DecisionField ,controlId ,controlData ,reduxContexts , "createworkitem" , containerId);
            }
            else {
              saveApplicationData();
            }
          }
        }
      }
    } else if (event.type === "keydown") {
      if (event.keyCode == 112) {
        if (eventJson && eventJson.Events && eventJson.Events.KeyPressF1) {
          elementEventJson = eventJson.Events.KeyPressF1;
          event.type = "KeyPressF1"; 
          eventName = "KeyPressF1";       
        }
      } else if (event.keyCode == 113) {
        if (eventJson && eventJson.Events && eventJson.Events.KeyPressF2) {
          elementEventJson = eventJson.Events.KeyPressF2;
          event.type = "KeyPressF2";   
          eventName = "KeyPressF2";        
        }
      } else if (event.keyCode == 114) {
        if (eventJson && eventJson.Events && eventJson.Events.KeyPressF3) {
          elementEventJson = eventJson.Events.KeyPressF3;
          event.type = "KeyPressF3";
          eventName = "KeyPressF3";
        }
      } else if (event.keyCode == 115) {
        if (eventJson && eventJson.Events && eventJson.Events.KeyPressF4) {
          elementEventJson = eventJson.Events.KeyPressF4;
          event.type = "KeyPressF4";
          eventName = "KeyPressF4";
        }
      }  else {
        if (eventJson && eventJson.Events && eventJson.Events["KeyDown"]) {
          elementEventJson = eventJson.Events["KeyDown"];
        }
      }
    } else if (event.type === "focus") {
      if (eventJson && eventJson.Events && eventJson.Events.GotFocus) {
        elementEventJson = eventJson.Events.GotFocus;
      }
    } else if (event.type === "blur") {
      if (eventJson && eventJson.Events && eventJson.Events.LostFocus) {
        elementEventJson = eventJson.Events.LostFocus;
      }
    } else if (event.type === "keypress") {
      if (event.keyCode == 112) {
        if (eventJson && eventJson.Events && eventJson.Events.keyPressF1) {
          elementEventJson = eventJson.Events.keyPressF1;
          event.type = "KeyPressF1";          
        }
      } else if (event.keyCode == 113) {
        if (eventJson && eventJson.Events && eventJson.Events.keyPressF2) {
          elementEventJson = eventJson.Events.keyPressF2;
          event.type = "KeyPressF2";
        }
      } else if (event.keyCode == 114) {
        if (eventJson && eventJson.Events && eventJson.Events.keyPressF3) {
          elementEventJson = eventJson.Events.keyPressF3;
          event.type = "KeyPressF3";
        }
      } else if (event.keyCode == 115) {
        if (eventJson && eventJson.Events && eventJson.Events.keyPressF4) {
          elementEventJson = eventJson.Events.keyPressF4;
          event.type = "KeyPressF4";
        }
      } else if (event.keyCode == 116) {
        if (eventJson && eventJson.Events && eventJson.Events.KeyPressF5) {
          elementEventJson = eventJson.Events.KeyPressF5;
          event.type = "KeyPressF5";
        }
      } else if (event.keyCode == 117) {
        if (eventJson && eventJson.Events && eventJson.Events.KeyPressF6) {
          elementEventJson = eventJson.Events.KeyPressF6;
          event.type = "KeyPressF6";
        }
      } else if (event.keyCode == 118) {
        if (eventJson && eventJson.Events && eventJson.Events.KeyPressF7) {
          elementEventJson = eventJson.Events.KeyPressF7;
          event.type = "KeyPressF7";
        }
      } else if (event.keyCode == 119) {
        if (eventJson && eventJson.Events && eventJson.Events.KeyPressF8) {
          elementEventJson = eventJson.Events.KeyPressF8;
          event.type = "KeyPressF8";
        }
      } else if (event.keyCode == 120) {
        if (eventJson && eventJson.Events && eventJson.Events.KeyPressF9) {
          elementEventJson = eventJson.Events.KeyPressF9;
          event.type = "KeyPressF9";
        }
      } else if (event.keyCode == 121) {
        if (eventJson && eventJson.Events && eventJson.Events.KeyPressF10) {
          elementEventJson = eventJson.Events.KeyPressF10;
          event.type = "KeyPressF10";
        }
      } else if (event.keyCode == 122) {
        if (eventJson && eventJson.Events && eventJson.Events.KeyPressF11) {
          elementEventJson = eventJson.Events.KeyPressF11;
          event.type = "KeyPressF11";
        }
      } else if (event.keyCode == 123) {
        if (eventJson && eventJson.Events && eventJson.Events.KeyPressF12) {
          elementEventJson = eventJson.Events.KeyPressF12;
          event.type = "KeyPressF12";
        }
      }
    } else if (event.type === "change" || event.type === "input") {
      if (eventJson && eventJson.Events && eventJson.Events.Change) {
        elementEventJson = eventJson.Events.Change;
        
      }
    } else if (event.type === "load") {
      if (eventJson && eventJson.Events && eventJson.Events.load) {
        elementEventJson = eventJson.Events.load;        
      }
    }
    if (eventsArray != null && elementEventJson != null) {
      if(controlData?.eventsInArray?.[eventName]){
        eventsArray=controlData?.eventsInArray?.[eventName]
      }
      for (var i = 0; i < eventsArray.length; i++) {
        if (eventsArray[i].value == "CustomAction") {
          if (
            elementEventJson.CustomAction &&
            elementEventJson.CustomAction != null &&
            elementEventJson.CustomAction != ""
          ) {
            var functionCall = elementEventJson.CustomAction;
            if (window[functionCall]) {
              window.loading(true);
              await window[functionCall](getHooksId(controlData, ref), event);
              functions.updateJSON();
            } else {
              const errorMsg = `The function: ${functionCall}, is not defined in custom code.`
              generalError_fn(errorMsg, errorMsg)
            }
          }
        } else if (eventsArray[i].value == "DBLinking") {
          if (
            elementEventJson.DBLinking &&
            elementEventJson.DBLinking.length > 0
          ) {
            // window.loading(true);
            const response1 = elementEventJson?.DBLinking
              ? elementEventJson
              : {};
            // const dbLinkingArray = response1?.DBLinking
            //   ? response1.DBLinking
            //   : "";
            // let dbLinkingArrayLength = dbLinkingArray?.length
            //   ? dbLinkingArray.length
            //   : 0;
            // const MaxLoopIteration = 99999;

            // if (dbLinkingArrayLength > MaxLoopIteration)
            //   dbLinkingArrayLength = MaxLoopIteration;

            // if (dbLinkingArrayLength < MaxLoopIteration) {
            //   for (var j = 0; j < dbLinkingArrayLength; j++) {
                var eventType = event.type;
                if (eventType == "focus") eventType = "GotFocus";
                if (eventType == "blur") eventType = "lostfocus";
                if (eventType == "load") eventType = "Load";
                var jsonToSend = {
                  DBLinkingEvent: eventType,
                  gdtoken: reduxContexts.gdtoken || "",
                  witoken: reduxContexts.witoken || "",
                  controlName: ref.id,
                  // Index: j,
                };
                if (ref.id === "root") {
                  jsonToSend["eventType"] = "1";
                }
                  const response = await executeDBLinking(jsonToSend);
                  if (
                    response &&
                    response.data &&
                    response.data.status === "0"
                  ) {
                    if (response.data.error === "false") {
                      var apiArray = response.data.APIData;
                      if (apiArray != null){
                        renderExecuteServerEventAPIData({
                          outputArray: apiArray,
                          isCalledFromDBLinking: true,
                          event: eventType,
                          // index: j,
                          renderFlag:true,
                          sync: true,
                        });
                        functions.updateJSON();
                      }
                      if (window.postHookDBLink) {
                        window.postHookDBLink(ref.id, event);
                        functions.updateJSON();
                        window.loading(false);
                      }
                      window.loading(false);
                    }
                    else {
                      window.loading(false);
                    }
                  }
                  else {
                    window.loading(false);
                  }
              // }
            // }
          }
        } else if (eventsArray[i].value == "Command") {
          if (
            elementEventJson.Command &&
            elementEventJson.Command != null &&
            elementEventJson.Command != ""
          ) {
            var commandName = elementEventJson.Command.Name;
            if (commandName == "WFSave") {
              console.log("wfsave reduxContexts", reduxContexts)
              if (
                reduxContexts?.contexts?.formMataData?.isMobileApplication ===
                "Y"
              ) {
                window?.triggerMobileCustomCode("saveWorkitem", "");
              }
              else{
                if (window.parent && window.parent.WFSave) {
                  window.parent.WFSave();
                }
              }
              // }
            } else if (commandName == "WFDone") {
              console.log("wfdone reduxContexts", reduxContexts)
              if (
                reduxContexts?.contexts?.formMataData?.isMobileApplication ===
                "Y"
              ) {
                window?.triggerMobileCustomCode("doneWorkitem", "");
              }
              else{
                if (window.parent && window.parent.WFDone) {
                  window.parent.WFDone();
                }
              }
              //}
            } else if (commandName == "WFClose") {
              if (window.parent && window.parent.CloseWorkitem) {
                window.parent.CloseWorkitem();
              }
              // }
            } else if (commandName == "NGExportToPDF") {
              const formJson = getFormJsonFromStore();

              var formName;
              if (builderMode !== "application" && builderMode !== "preview") {
                formName = window?.WDeskData?.Processname;
              } else {
                formName = formJson?.formName;
              }
              formStateStore.dispatch(updateStateInRedux({name: "callTakeScreenshot", value: true}));
            } else if (commandName == "NGLaunchURL") {
              var parameters = elementEventJson.Command.Parameters;
             const newWin = window.open(
                parameters?.url,
                parameters.windowName,
                parameters.windowDecoration
              );
              handleWinObjects(newWin);
            } else if (commandName == "WFRefresh Interfaces") {
              if (window.parent.RefreshWorkitem)
                window.parent.RefreshWorkitem();
            } else if (commandName == "RouteCriteria") {
              executeRouteCriteria(reduxContexts, eventJson, ref);
            } else if (commandName == "RouteJourney") {
               // selectedTileIndex
               var controlId = "";
               var FormName = eventJson.Events["Click"].Command.Parameters.FormName;
               var DecisionField = eventJson?.Events?.["Click"]?.Command?.Parameters?.DecisionField;

               if (controlData.elem_type === "tile") {
                   controlId = controlData?.tileContents?.[selectedTileIndex]?.id;
                   FormName = eventJson.Events["Click"].Command?.ParametersArray?.find(item => item.TileName === controlId)?.FormName
                   DecisionField = eventJson.Events["Click"].Command?.ParametersArray?.find(item => item.TileName === controlId)?.DecisionField
               }
               else {
                   controlId = controlData?.id;
               }
               if(FormName && DecisionField){
                 executeRouteJourney1(FormName,DecisionField,controlId,controlData,reduxContexts, "routejourney", containerId )
               }

            } else if (commandName.toLowerCase() == "validateotp") {
              var parameters1 = {
                OTPField:
                  eventJson.Events["Click"]?.Command?.Parameters?.OTPField,
              };
              await functions
                .executeServerEvent(
                  "controlName",
                  "click",
                  JSON.stringify(parameters1),
                  true
                )
                .then((result) => {
                  if (
                    result?.data?.error === "false" &&
                    result?.data?.responseData === "true"
                  ) {
                    const applicationId =
                      reduxContexts?.contexts?.openingAsApplication
                        ?.applicationId;
                    const nextPage =
                      eventJson?.Events?.["Click"]?.Command?.Parameters
                        ?.FormName;

                    axios
                      .get(`interfacesbyname/${applicationId}/${nextPage}`, {
                        withCredentials: true,
                        headers: {
                          mode: window.isDesigner ? "D" : "V",
                        },
                      })
                      .then((res) => {
                        if (res.data.status === "1") {
                          showAlertConfirmNotifications({
                            open: true,
                            showConfirm: "showNotification",
                            alertType: "error",
                            alertContentKey:
                              res?.data?.err_msg_description ||
                              "some error occured",
                          });
                        } 
                        else if(res?.data?.err_Msg && res?.data?.status==="-2"){
                          showAlertConfirmNotifications({
                            'open':true,
                            'showConfirm':'showNotification',
                            'alertType':'error',
                            'alertContentKey': res?.data?.err_Msg || "some error occured"
                          });
                        }
                        else {

                          const stage = res?.data?.Stage;
                          if(stage){

                            formStateStore.dispatch(
                              updateStore({
                                name: "wizard_stage",
                                value: stage,
                                key: containerId,
                              })
                            );
                            window.wizard_stage_fromOpenTransaction = stage;
                          }

                          formStateStore.dispatch(updateFormStateWithoutRender(res?.data?.formJson));
                          batch(() => {
                            setActivePage(res?.data?.formJson);
                            setFormState2(res?.data?.formJson);
                          });
                          window.formBuilder_transactionid_generalData= res?.data?.TransactionId;

                          if (
                            res?.data?.SelectionPage &&
                            res?.data?.SelectionPage.toString().length > 0
                          ) {
                            formStateStore.dispatch(
                              updateRouteJourneySelectionPage({
                                key: containerId,
                                value: res?.data?.SelectionPage.toString(),
                              })
                            );
                          }
                        }
                      })
                      .catch((err) => {
                        showAlertConfirmNotifications({
                          open: true,
                          showConfirm: "showNotification",
                          alertType: "error",
                          alertContentKey:
                            err?.data?.errorode || "some error occured",
                        });
                      });
                  } else {
                    setLoginErrorPage(true);
                  }
                });
            } else if (commandName.toLowerCase() == "opentransaction") {
              const referenceKey_name =
                eventJson?.Events?.["Click"]?.Command?.Parameters
                  ?.TransactionColumnName || "referencekey";
              const routejourney_name =
                eventJson?.Events?.["Click"]?.Command?.Parameters
                  ?.RouteJourneyColumnName || "routejourney";
              const navigationform_name =
                eventJson?.Events?.["Click"]?.Command?.Parameters
                  ?.NavigationFormColumnName || "navigationform";

              const selectedRowJsonList = getSelectedTableRow();

              const attachedTableId =
                eventJson?.Events?.["Click"]?.Command?.Parameters
                  ?.TransactionSelectionControl;

              const selectedRowJson = selectedRowJsonList[attachedTableId];

              var TransactionNumber = selectedRowJson?.[referenceKey_name];
              var stage_fromTable = selectedRowJson?.stage;
              var routeJourneyColName = selectedRowJson?.[routejourney_name];
              var navFormColName = selectedRowJson?.[navigationform_name];

              var next_FormName_fromEvent =
                eventJson?.Events?.["Click"]?.Command?.Parameters?.NextFormName;

              formStateStore.dispatch(
                updateStore({
                  name: "wizard_stage",
                  value: stage_fromTable,
                  key: containerId,
                })
              );
              window.wizard_stage_fromOpenTransaction = stage_fromTable;

              function activeNextPage() {
                if (
                  eventJson?.Events?.["Click"]?.Command?.Parameters
                    ?.DynamicJourney === "true"
                ) {
                  return navFormColName;
                } else {
                  return next_FormName_fromEvent;
                }
              }

              const json = {
                gdtoken: reduxContexts.gdtoken,
                parameters: JSON.stringify({
                  MDMTable:
                    eventJson.Events["Click"].Command.Parameters.MDMTable || "",
                  TransactionNumber: TransactionNumber || "",
                  FormName: next_FormName_fromEvent || "",
                  ISWidget:
                    eventJson.Events["Click"].Command.Parameters.ISWidget || "",
                  DynamicJourney:
                    eventJson.Events["Click"].Command.Parameters
                      .DynamicJourney || "",
                  routeJourneyColName: routeJourneyColName || "",
                  navFormColName: navFormColName || "",
                }),
              };

              axios
                .post("/viewform/openTransaction", json, {
                  withCredentials: true,
                })
                .then((res) => {
                  if (res.data.status === "true") {
                    const applicationId =
                      reduxContexts?.contexts?.openingAsApplication
                        ?.applicationId;
                    axios
                      .get(
                        `interfacesbyname/${applicationId}/${activeNextPage()}`,
                        {
                          withCredentials: true,
                          headers: {
                            mode: window.isDesigner ? "D" : "V",
                          },
                        }
                      )
                      .then((resp) => {
                        if (resp.data.status === "1") {
                          showAlertConfirmNotifications({
                            open: true,
                            showConfirm: "showNotification",
                            alertType: "error",
                            alertContentKey:
                              resp?.data?.err_msg_description ||
                              "some error occured",
                          });
                        } 
                        else if(resp?.data?.err_Msg && resp?.data?.status==="-2"){
                          showAlertConfirmNotifications({
                            'open':true,
                            'showConfirm':'showNotification',
                            'alertType':'error',
                            'alertContentKey': resp?.data?.err_Msg || "some error occured"
                          });
                        }
                        
                        else {

                          const stage = resp?.data?.Stage;
                          if(stage){

                            formStateStore.dispatch(
                              updateStore({
                                name: "wizard_stage",
                                value: stage,
                                key: containerId,
                              })
                            );
                            window.wizard_stage_fromOpenTransaction = stage;
                          }

                          window.formBuilder_transactionid_generalData= resp?.data?.TransactionId;
                          formStateStore.dispatch(updateFormStateWithoutRender(resp?.data?.formJson));
                          batch(() => {
                            setActivePage(resp?.data?.formJson);
                            setFormState2(resp?.data?.formJson);
                          })

                          if (
                            resp?.data?.SelectionPage &&
                            resp?.data?.SelectionPage.toString().length > 0
                          ) {
                            formStateStore.dispatch(
                              updateRouteJourneySelectionPage({
                                key: containerId,
                                value: resp?.data?.SelectionPage.toString(),
                              })
                            );
                          }
                        }
                      })
                      .catch((err) => {
                        console.log(err);
                      });
                  } else if (res.data.status !== "true") {
                    showAlertConfirmNotifications({
                      open: true,
                      showConfirm: "showNotification",
                      alertType: "error",
                      alertContentKey:
                        res?.data?.errorode || "some error occured",
                    });
                  }
                })
                .catch((err) => {
                  showAlertConfirmNotifications({
                    open: true,
                    showConfirm: "showNotification",
                    alertType: "error",
                    alertContentKey:
                      err?.data?.errorode || "some error occured",
                  });
                });
            } else if (commandName.toLowerCase() == "createtransaction") {
              const applicationId =
                reduxContexts?.contexts?.openingAsApplication?.applicationId;
              const nextPage =
                eventJson?.Events?.["Click"]?.Command?.Parameters?.FormName;

              axios
                .get(`interfacesbyname/${applicationId}/${nextPage}`, {
                  withCredentials: true,
                  headers: {
                    mode: window.isDesigner ? "D" : "V",
                    createNew: isLoginTypeVar ? "Y" : "",
                  },
                })
                .then((res) => {
                  if (res.data.status === "1") {
                    showAlertConfirmNotifications({
                      open: true,
                      showConfirm: "showNotification",
                      alertType: "error",
                      alertContentKey:
                        res?.data?.err_msg_description || "some error occured",
                    });
                  } 
                  else if(res?.data?.err_Msg && res?.data?.status==="-2"){
                    showAlertConfirmNotifications({
                      'open':true,
                      'showConfirm':'showNotification',
                      'alertType':'error',
                      'alertContentKey': res?.data?.err_Msg || "some error occured"
                    });
                  }
                  else {
                    
                    const stage = res?.data?.Stage;
                    if(stage){

                      formStateStore.dispatch(
                        updateStore({
                          name: "wizard_stage",
                          value: stage,
                          key: containerId,
                        })
                      );
                      window.wizard_stage_fromOpenTransaction = stage;
                    }

                    formStateStore.dispatch(updateFormStateWithoutRender(res?.data?.formJson));
                    batch(() => {
                      setActivePage(res?.data?.formJson);
                      setFormState2(res?.data?.formJson);
                    })
                    window.formBuilder_transactionid_generalData= res?.data?.TransactionId;
                    

                    if (
                      res?.data?.SelectionPage &&
                      res?.data?.SelectionPage.toString().length > 0
                    ) {
                      formStateStore.dispatch(
                        updateRouteJourneySelectionPage({
                          key: containerId,
                          value: res?.data?.SelectionPage.toString(),
                        })
                      );
                    }
                  }
                })
                .catch((err) => {
                  showAlertConfirmNotifications({
                    open: true,
                    showConfirm: "showNotification",
                    alertType: "error",
                    alertContentKey:
                      err?.data?.errorode || "some error occured",
                  });
                });
            } else if (commandName.toLowerCase() == "getpicklistdata") {
              var getPicklistParams = elementEventJson.Command.Parameters;
              var getPicklistJsonToSend = {
                columnId: -1,
                gdtoken: gdtoken,
                controlId: ref.id,
                batchSize: parseInt(getPicklistParams?.BatchSize) || 10,
                pageNo: 1
              };

              try {
                const getPicklistResponse = await axios.post(
                  "/pickListView/populatePicklistDataFromDB",
                  getPicklistJsonToSend,
                  { withCredentials: true }
                );
                const getPicklistResult = getPicklistResponse?.data || {};
                controlData._getPicklistDataResult = {
                  PickListColumn: getPicklistResult?.PickListColumn || [],
                  PickListData: getPicklistResult?.PickListData || [],
                  Pages: getPicklistResult?.Pages || 0,
                  lastPage: getPicklistResult?.lastPage || false,
                  WidthMap: getPicklistResult?.WidthMap || {},
                  enableColumnMap: getPicklistResult?.enableColumnMap || {},
                  defaultColumnValue: getPicklistResult?.defaultColumnValue || "",
                  batchSize: parseInt(getPicklistParams?.BatchSize) || 10,
                  popupTitle: getPicklistParams?.PopupTitle || "",
                  controlId: ref.id,
                  gdtoken: gdtoken,
                };
              } catch (getPicklistErr) {
                console.log("getPicklistData error:", getPicklistErr);
                showAlertConfirmNotifications({
                  open: true,
                  showConfirm: "showNotification",
                  alertType: "error",
                  alertContentKey: "Failed to fetch picklist data",
                });
              }
            }
          }
        } else if (eventsArray[i].value == "CustomWebService") {
          if (
            elementEventJson.CustomWebService &&
            elementEventJson.CustomWebService != null &&
            elementEventJson.CustomWebService != ""
          ) {
            if (window.customWebServicePreHook) {
              if (!window.customWebServicePreHook(ref.id)) {
                return;
              }
              functions.updateJSON();
            }
            var jsonToSend = { controlId: ref.id, eventType: event.type };
            executeCustomService(jsonToSend).then((response) => {
              var message = response.data.message;
              var ResponseCode = response.data.ResponseCode;
              if (typeof message != "undefined" && message != "") {
                if (ResponseCode != "0") {
                  showAlertConfirmNotifications({
                    open: true,
                    showConfirm: "showNotification",
                    alertType: "error",
                    alertContentKey: message,
                  });
                } else {
                  showAlertConfirmNotifications({
                    open: true,
                    showConfirm: "showNotification",
                    alertType: "success",
                    alertContentKey: message,
                  });
                }
              }
              const responseCheck1 = response?.data ? response : {};
              const responseCheck2 = responseCheck1
                ? responseCheck1?.data
                  ? responseCheck1?.data
                  : {}
                : {};
              var outputArray = responseCheck2
                ? responseCheck2?.responseData
                  ? responseCheck2?.responseData
                  : []
                : [];
              var apiArray = response.data.APIData;
              if (apiArray != null)
              {
                renderExecuteServerEventAPIData({ outputArray: apiArray, sync: true, renderFlag:true });
                functions.updateJSON();
              }
              
              // for (var i = 0; i < outputArray.length; i++) {
              //   for (var j = 0; j < outputArray[i].length; j++) {
              //     try {
              //       var dataArray = outputArray[i][j];
              //       var controlId = dataArray.id;
              //       var type = dataArray.type;
              //       var dataValue = dataArray.value.value;
              //       if (
              //         type == "textarea" ||
              //         type == "textbox" ||
              //         type == "label" ||
              //         type == "combo" ||
              //         type == "checkbox" ||
              //         type == "radio" ||
              //         type == "datepick"
              //       ) {
              //         functions.setValues({controlId : dataValue}, true);
              //       } else if (type == "table") {
              //         var formjson = getFormJsonFromStore;
              //         var eleJSON = recursiveJsonReader1(
              //           formjson,
              //           controlId,
              //           "table"
              //         );
              //         if (dataArray.isAppendData) {
              //           eleJSON.rowData.push(...dataArray.value.value);
              //         } else {
              //           eleJSON.rowData = [];
              //           eleJSON.rowData.push(...dataArray.value.value);
              //         }
              //         if (window.addRowPostHook) {
              //           window.addRowPostHook(getHooksId(eleJSON), "customAPI");
              //           functions.updateJSON()
              //         }
              //       }
              //     } catch (ex) {}
              //   }
              //   
              // }
              if (window?.customWebServicePostHook) {
                  window.customWebServicePostHook(ref.id);
                  functions.updateJSON();
                }
            });
          }
        }
        else if(eventsArray[i].value == "WebService"){
          if (
            elementEventJson.WebService &&
            elementEventJson.WebService != null &&
            elementEventJson.WebService != ""
          ) {
            if (window.webServicePreHook) {
              if (!window.webServicePreHook(getHooksId(controlData))) {
                return;
              }
              functions.updateJSON()
            }
            executeWebService(
              controlData.id,
              eventName,
              reduxContexts.gdtoken,
              reduxContexts.witoken
            ).then(async(response) => {
              if(response?.data?.Error && response?.data?.Error === "true"){
                let message = response?.data?.errormessage?.split(" ")
                showAlertConfirmNotifications({
                    open: true,
                    showConfirm: "showNotification",
                    alertType: "error",
                    alertContentKey: `Data Object rights missing for param ${message[message?.length - 1]}`,
                  });
              } else {
                await webServiceFunction(response);
                if (window.webServicePostHook) {
                  if (!window.webServicePostHook(controlData.id)) {
                    return;
                  }
                  functions.updateJSON()
                }
              }
            });
          }          
        }
      }
    }
  }
}

export async function executeRouteCriteria(reduxContexts, eventJson, ref) {
  if (reduxContexts.gdtoken && reduxContexts.witoken) {
    const setFormState2 = reduxContexts?.contexts?.setFormState2;
    const setActivePage = reduxContexts?.contexts?.setActivePage;
    const showAlertConfirmNotifications =
      reduxContexts?.contexts?.showAlertConfirmNotifications;
    const applicationNameObj = reduxContexts?.contexts?.applicationNameObj;

    const passValue = await encrypt(functions.getValue(eventJson.Events["Click"].Command.Parameters.Password) || "")

    function encrypt_method(val){
      let returnvalue = encrypt(val)
      return returnvalue;
    }

    async function forceLogin() {
      const username_id = eventJson?.Events?.["Click"]?.Command?.Parameters?.UserName || "username_id";
    const password_id = eventJson?.Events?.["Click"]?.Command?.Parameters?.Password || "password_id";

    const username_val_dom = document.querySelector(`#${username_id}`)?.getAttribute("value") || document.querySelector(`[name='${username_id}']`)?.value || document.querySelector(`[name='${username_id}']`)?.getAttribute("valueoftext") || "";
    let password_val_dom = document.querySelector(`#${password_id}`)?.getAttribute("value") || document.querySelector(`[name='${password_id}']`)?.value || document.querySelector(`[name='${password_id}']`)?.getAttribute("valueoftext") || "";
      password_val_dom = await encrypt_method(password_val_dom);

      const json = {
        gdtoken: reduxContexts.gdtoken,
        witoken: reduxContexts.witoken,
        parameters: JSON.stringify({
          FormName: eventJson.Events["Click"].Command.Parameters.FormName,
          userNameVal: functions.getValue(
            eventJson.Events["Click"].Command.Parameters.UserName
          ),
          UserName: eventJson.Events["Click"].Command.Parameters.UserName,
          Password: eventJson.Events["Click"].Command.Parameters.Password,
          passwordVal: passValue,
          [username_id]: username_val_dom,
          [password_id]: password_val_dom,
          CaptchaControl:
            eventJson.Events["Click"].Command?.Parameters?.CaptchaControl || "",
          captchaVal: eventJson.Events?.["Click"]?.Command?.Parameters
            ?.CaptchaControl
            ? document
                .querySelectorAll(
                  `#${eventJson.Events?.["Click"]?.Command?.Parameters?.CaptchaControl}`
                )?.[0]
                ?.getAttribute("value")
            : "",
        }),
        controlName: ref.id
      };

      axios
        .post("/viewform/forcedLogin", json, { 
          headers: { 
            clientGMTOffset: Math.abs(new Date().getTimezoneOffset()),
          }, 
          withCredentials: true 
        })
        .then((res) => {
          if (res.data?.status === "0") {
            showAlertConfirmNotifications({
              open: true,
              showConfirm: "showNotification",
              alertType: "error",
              alertContentKey: "Invalid Username or Password",
            });
          } else if (res.data?.status === "1") {
            showAlertConfirmNotifications({
              open: true,
              showConfirm: "showNotification",
              alertType: "error",
              alertContentKey: res?.data?.err_msg_description,
            });
          }
          else if(res?.data?.err_Msg && res?.data?.status==="-2"){
            showAlertConfirmNotifications({
              'open':true,
              'showConfirm':'showNotification',
              'alertType':'error',
              'alertContentKey': res?.data?.err_Msg || "some error occured"
            });
          }
           else {
            try {
              const loggedInUserData =
                reduxContexts?.contexts?.loggedInUserData;
              const setLoggedInUserData =
                reduxContexts?.contexts?.setLoggedInUserData;
              window.formBuilder_transactionid_generalData= res?.data?.TransactionId;
              if (setLoggedInUserData !== undefined) {
                setLoggedInUserData({
                  ...loggedInUserData,
                  loggedInUserName:
                    res?.data?.personalName ||
                    functions.getValue(
                      eventJson.Events["Click"].Command.Parameters.UserName
                    ),
                  lastLoggedInTime: res?.data?.lastLoginTime,
                });
              }
            } catch (err) {
              console.log("Error :: ", err);
            }
            const setisMicroSerciceChecks =
              reduxContexts?.contexts?.setisMicroSerciceChecks;
            setisMicroSerciceChecks({
              IsMicroserviceMode: res?.data?.isMicroserviceMode || "N",
              MicroAuthParam: res?.data?.MicroAuthParam,
              MicroAuthToken: res?.data?.MicroAuthToken,
              MicroAuthUser: res?.data?.MicroAuthUser,
              cabinetName: reduxContexts?.contexts?.cabinetName,
            });

            const formJsonParsed = res.data.formJson;
            var parentTable = [
              ...formJsonParsed?.TableList?.filter(
                (item) => Object.keys(item)[0] === "parenttable"
              ),
            ][0];
            var tableList = [
              ...formJsonParsed?.TableList?.filter(
                (item) => Object.keys(item)[0] !== "parenttable"
              ),
            ];
            if(res?.data?.APIData) {
              renderExecuteServerEventAPIData({outputArray: res?.data?.APIData, sync: true, renderFlag: false, json: res?.data?.formJson});
            }
            formStateStore.dispatch(updateFormStateWithoutRender(res?.data?.formJson));
            batch(() => {
              setActivePage(res?.data?.formJson);
              setFormState2(res?.data?.formJson);
            })

            const auth = res?.data?.Authorization || "";
            axios.defaults.headers.common["Authorization"] = auth;
            window.setParent_auth_iforms(auth);

            const keyValue = JSON.stringify({ token: auth });

            const lauchpad_key_get =
              JSON.parse(
                secureLocalStorage.getItem(
                  window.isPortalLive
                    ? `launchpadKey_${applicationNameObj.applicationName}` || `launchpadKey_bypass_${applicationNameObj.applicationName}` ||
                        "launchpadKey"
                    : "launchpadKey"
                )
              )?.token || undefined;

            if (!lauchpad_key_get || lauchpad_key_get === "") {
              secureLocalStorage.setItem(
                window.isPortalLive
                  ? `launchpadKey_${applicationNameObj?.applicationName}`
                  : "launchpadKey",
                keyValue
              );
            }

            if (applicationNameObj?.applicationName) {
              const keyName = `launchpadKey_${applicationNameObj?.applicationName}`;
              secureLocalStorage.setItem(keyName, keyValue);
            }

            
            showAlertConfirmNotifications({
              open: true,
              showConfirm: "showNotification",
              alertType: "success",
              alertContentKey: "Logged In Successfully",
              autoHideDuration: window?.psh_configs?.LoggedInAlertDuration ? (window?.psh_configs?.LoggedInAlertDuration > 0 && window?.psh_configs?.LoggedInAlertDuration <= 8) && (window?.psh_configs?.LoggedInAlertDuration*1000) : undefined,
            });
            if (window?.psh_configs?.LoggedInAlertDuration){
              if(!(window?.psh_configs?.LoggedInAlertDuration > 0 && window?.psh_configs?.LoggedInAlertDuration <= 8)){
                showAlertConfirmNotifications({
                  open: true,
                  showConfirm: "showNotification",
                  alertType: "error",
                  alertContentKey: "LoggedInAlertDuration value in config.js should be between 1 to 8 seconds",
                });
              }
            }
          }
        })
        .catch((err) => {
          console.log("###executeLogin", err);
          showAlertConfirmNotifications({
            open: true,
            showConfirm: "showNotification",
            alertType: "error",
            alertContentKey: err.response?.message || "error",
          });
        });
    }

    const username_id = eventJson?.Events?.["Click"]?.Command?.Parameters?.UserName || "username_id";
    const password_id = eventJson?.Events?.["Click"]?.Command?.Parameters?.Password || "password_id";

    const username_val_dom = document.querySelector(`#${username_id}`)?.getAttribute("value") || document.querySelector(`[name='${username_id}']`)?.value || document.querySelector(`[name='${username_id}']`)?.getAttribute("valueoftext") || "";
    let password_val_dom = document.querySelector(`#${password_id}`)?.getAttribute("value") || document.querySelector(`[name='${password_id}']`)?.value || document.querySelector(`[name='${password_id}']`)?.getAttribute("valueoftext") || "";
    password_val_dom = await encrypt_method(password_val_dom);

    const json = {
      gdtoken: reduxContexts.gdtoken,
      witoken: reduxContexts.witoken,
      parameters: JSON.stringify({
        FormName: eventJson.Events["Click"].Command.Parameters.FormName || "",
        userNameVal:
          functions.getValue(
            eventJson.Events["Click"].Command.Parameters.UserName
          ) || "",
        UserName: eventJson.Events["Click"].Command.Parameters.UserName || "",
        Password: eventJson.Events["Click"].Command.Parameters.Password || "",
        passwordVal: passValue,
        [username_id]: username_val_dom,
        [password_id]: password_val_dom,
        CaptchaControl:
          eventJson.Events["Click"].Command?.Parameters?.CaptchaControl || "",
        captchaVal: eventJson.Events?.["Click"]?.Command?.Parameters
          ?.CaptchaControl
          ? document
              .querySelectorAll(
                `#${eventJson.Events?.["Click"]?.Command?.Parameters?.CaptchaControl}`
              )?.[0]
              ?.getAttribute("value")
          : "",
      }),
      controlName: ref.id,
    };
    axios
      .post("/viewform/executeLogin", json, { 
        headers: { 
          clientGMTOffset: Math.abs(new Date().getTimezoneOffset()),
        },
        withCredentials: true 
      })
      .then((res) => {
        if (res.data?.status === "-2") {
          showAlertConfirmNotifications({
            open: true,
            showConfirm: "showconformationDialogBox",
            alertContentKey: "ForceLoginContent",
            alertTitleKey: "ForceLoginTitle",
            Button1Key: "CancelButton",
            Button2Key: "LoginButton",
            forceLogin: forceLogin,
          });
        } else if (res.data?.status === "-1") {
          showAlertConfirmNotifications({
            open: true,
            showConfirm: "showNotification",
            alertType: "error",
            alertContentKey: res?.data?.message,
          });
        } else if (res.data?.status === "1") {
          showAlertConfirmNotifications({
            open: true,
            showConfirm: "showNotification",
            alertType: "error",
            alertContentKey:
              res?.data?.err_msg_description || "some error occured",
          });
        } else {
          try {
            const loggedInUserData = reduxContexts?.contexts?.loggedInUserData;
            window.formBuilder_transactionid_generalData= res?.data?.TransactionId;
            const setLoggedInUserData =
              reduxContexts?.contexts?.setLoggedInUserData;
            if (setLoggedInUserData !== undefined) {
              setLoggedInUserData({
                ...loggedInUserData,
                loggedInUserName:
                  res?.data?.personalName ||
                  functions.getValue(
                    eventJson.Events["Click"].Command.Parameters.UserName
                  ),
                lastLoggedInTime: res?.data?.lastLoginTime,
              });
            }
          } catch (err) {
            console.log("Error :: ", err);
          }
          const setisMicroSerciceChecks =
            reduxContexts?.contexts?.setisMicroSerciceChecks;
          setisMicroSerciceChecks({
            IsMicroserviceMode: res?.data?.isMicroserviceMode || "N",
            MicroAuthParam: res?.data?.MicroAuthParam,
            MicroAuthToken: res?.data?.MicroAuthToken,
            MicroAuthUser: res?.data?.MicroAuthUser,
            cabinetName: reduxContexts?.contexts?.cabinetName,
          });

          const formJsonParsed = res.data.formJson;
          var parentTable = [
            ...formJsonParsed?.TableList?.filter(
              (item) => Object.keys(item)[0] === "parenttable"
            ),
          ][0];
          var tableList = [
            ...formJsonParsed?.TableList?.filter(
              (item) => Object.keys(item)[0] !== "parenttable"
            ),
          ];
          if(res?.data?.APIData) {
            renderExecuteServerEventAPIData({outputArray: res?.data?.APIData, sync: true, renderFlag: false, json: res?.data?.formJson});
          }
          formStateStore.dispatch(updateFormStateWithoutRender(res?.data?.formJson));
          batch(() => {
            setActivePage(res?.data?.formJson);
            setFormState2(res?.data?.formJson);
          })
          
          const auth = res?.data?.Authorization || "";
          axios.defaults.headers.common["Authorization"] = auth;
          window.setParent_auth_iforms(auth);
          
          const keyValue = JSON.stringify({ token: auth });
          const lauchpad_key_get =
            JSON.parse(
              secureLocalStorage.getItem(
                window.isPortalLive
                  ? `launchpadKey_${applicationNameObj.applicationName}` || `launchpadKey_bypass_${applicationNameObj.applicationName}` || 
                      "launchpadKey"
                  : "launchpadKey"
              )
            )?.token || undefined;
          if (!lauchpad_key_get || lauchpad_key_get === "") {
            secureLocalStorage.setItem(
              window.isPortalLive
                ? `launchpadKey_${applicationNameObj.applicationName}`
                : "launchpadKey",
              keyValue
            );
          }
          if (applicationNameObj?.applicationName) {
            const keyName = `launchpadKey_${applicationNameObj?.applicationName}`;
            secureLocalStorage.setItem(keyName, keyValue);
          }

          console.log("lauchpad_key_get", lauchpad_key_get);

          showAlertConfirmNotifications({
            open: true,
            showConfirm: "showNotification",
            alertType: "success",
            alertContentKey: "Logged In Successfully",
          });
        }
      })
      .catch((err) => {
        console.log("###executeLogin", err.response);
        if (err.response.data.status === "-2") {
          showAlertConfirmNotifications({
            open: true,
            showConfirm: "showNotification",
            alertType: "error",
            alertContentMsg: err.response.data?.message,
          });
        } else if (err.response.data.status === "-3") {
          showAlertConfirmNotifications({
            open: true,
            showConfirm: "showNotification",
            alertType: "error",
            alertContentMsg: err.response.data?.message,
          });
        } else {
          showAlertConfirmNotifications({
            open: true,
            showConfirm: "showNotification",
            alertType: "error",
            alertContentMsg: "An error occurred while logging. Please try again.",
          });
        }
      });
  }
}
export async function executeRouteJourney1 (FormName,DecisionField,controlId, controlData, reduxContexts, eventtypo, containerId) {

  let checkTileHook=false;
  if(window.navigateOnTileClick && controlData?.elem_type === "tile"){
    checkTileHook=window.navigateOnTileClick(controlData)
  }
  if(checkTileHook || controlData?.elem_type === "button" || controlId==="LoginHeader"){
    
  const {  
    showAlertConfirmNotifications,
    setFormState2,
    setActivePage,
    setSelectionPage
  } = reduxContexts?.contexts;
//  const setFormState2 = reduxContexts?.contexts?.setFormState2;

  const formId= reduxContexts?.contexts?.formState2?.formId;

  const applicationDataJson={
    "gdtoken":reduxContexts.gdtoken,
    "witoken":reduxContexts.witoken,
    "applicationName":reduxContexts?.contexts?.openingAsApplication?.applicationName,
    "applicationId":reduxContexts?.contexts?.openingAsApplication?.applicationId, 
    "submitApplication": eventtypo==="routejourney" ? "N" : "Y",
    "stepIndex": "0",
    "stepSubIndex": "0",
    "isBackClicked": false,
    "formName": formId,
    "eventSource": eventtypo==="routejourney" ? "app" : controlData?.eventSource
}

const callExecuteRouteJourney = (eventtypo) => {
  if(eventtypo==="routejourney" && (!FormName)){
    showAlertConfirmNotifications({
      open: true,
      showConfirm: "showNotification",
      alertType: "error",
      alertContentKey: "Form name is mandatory"
      });
    return;
  }
  const json={
    // {"parameters":"{\"DecisionField\":\"textbox1\",\"FormName\":\"Page 2\",\"DecisionFieldVal\":\"Page 3\"}"}
    "parameters":JSON.stringify({
        "DecisionField":DecisionField,
        "FormName":FormName,
        "DecisionFieldVal": eventtypo==="routejourney" ? functions.getValue(DecisionField) : ""
    }),                        
    "gdtoken":reduxContexts.gdtoken || "TestProcess-0000000003-process_GeneralData",
    "controlId":controlId || ""
}

axios.post("/viewform/executeRouteJourney",json,{withCredentials:true})
.then(res=>{

    if(res.data?.status === "1") {
        showAlertConfirmNotifications({
            open: true,
            showConfirm: "showNotification",
            alertType: "error",
            alertContentKey: res?.data?.err_msg_description
        });
    }else {

      const stage = res?.data?.Stage;

        if(stage){
          formStateStore.dispatch(
            updateStore({
              name: "wizard_stage",
              value: stage,
              key: containerId,
            })
          );
          window.wizard_stage_fromOpenTransaction = stage;
        }
        else{
          formStateStore.dispatch(
            updateStore({
              name: "wizard_stage",
              value: "0:0",
              key: containerId,
            })
          );
          window.wizard_stage_fromOpenTransaction = "0:0";
        }
        
    window.formBuilder_transactionid_generalData= res?.data?.TransactionId;
            const formJsonParsed= res.data.formJson;
            var parentTable=[...formJsonParsed?.TableList?.filter(item => Object.keys(item)[0]==="parenttable")][0];
            var tableList=[...formJsonParsed?.TableList?.filter(item => Object.keys(item)[0]!=="parenttable")];
            if(res?.data?.APIData) {
              renderExecuteServerEventAPIData({outputArray: res?.data?.APIData, sync: true, renderFlag: false, json: res?.data?.formJson});
            }
            formStateStore.dispatch(updateFormStateWithoutRender(res?.data?.formJson));
            batch(() => {
              setActivePage(res?.data?.formJson);
              setFormState2(res?.data?.formJson);
            })

        formStateStore.dispatch(updateFormStateContext({  value: res?.data?.formJson }));
        

        if(res?.data?.SelectionPage && res?.data?.SelectionPage.toString().length>0){
            setSelectionPage(res?.data?.SelectionPage.toString());
        }

        
    }
  
    })
.catch(err=>{
      console.log(err);
})
}

await axios.post("/viewform/saveApplicationData",applicationDataJson,{withCredentials:true})
.then((response)=>{

    if(response?.data?.APIData) {
      renderExecuteServerEventAPIData({outputArray: response?.data?.APIData, sync: true, renderFlag:true});
    }
    if(response?.headers?.workitemlist !== undefined && response?.headers?.workitemlist !== ""){     
      
      // shivam_review correction needed @shalvi (workitemlist message stopped coming )
      if (window?.showSuccessMessageInApplication) {
        window?.showSuccessMessageInApplication(response?.headers?.workitemlist);
      }
      showAlertConfirmNotifications({
        'open':true,
        'showConfirm':'showNotification',
        'alertType':'success',
        "vertical": 'bottom', 
        "horizontal": 'left', 
        'alertContentKey':`${response?.headers?.workitemlist} created successfully`,
        'autoHideDuration': 3000
      });
    }
})
.catch(err =>{
    console.log(err);
})

  callExecuteRouteJourney(eventtypo);
  }
}